import * as React from 'react';
import { Colors } from '@origin-digital/style-guide';
import styled from 'styled-components';
import { LG, MD, SM, XL } from '@origin-digital/helper';
import { Header } from './Header';
import { isNative } from 'ts/services/native/native';

interface PageProps {
  children: React.ReactChild;
  image?: string;
}

const Page: React.FC<PageProps> = ({ children }) => (
  <OuterOuterDiv>
    {!isNative() && <Header />}
    <OuterDiv data-id="card-outer-div" data-name="LoginPage">
      <CenteredBox data-id="card-inner-div">{children}</CenteredBox>
    </OuterDiv>
  </OuterOuterDiv>
);

const OuterOuterDiv = styled.div`
  display: flex;
  flex-flow: column;
  min-height: 100vh;
  height: 100vh;
`;

const OuterDiv = styled.div`
  flex-grow: 1;
  display: flex;
  ${SM`
    display: block;
    background-color: ${Colors.WHITE};
  `}
  ${MD`
    display: flex;
    flex-direction: column;
  `}
`;

const CenteredBox = styled.div`
  width: 100vw;
  margin: 8px 0 0 0;
  position: relative;
  ${SM`
     width: 508px;
    margin: 8px auto;
    min-height: auto;
    height: auto;
  `}
  ${MD`
    width: 448px;
    margin: auto;
  `}
  ${LG`
    // everything the same as MD
  `}
  ${XL`
    width: 538px;
  `}
`;

export { Page, CenteredBox };
